import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Breadcrumb, Col, Modal, Row } from 'antd';
import { QRCode } from 'antd';

import { SettingsManager } from '@classes/settingsManager';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type TProps = {
    dataId: number | string;
    dataIcon: IconProp;
    title: string;
    dataTitle: string;
    route: string;
    dataName: string;
    isForInvitation: boolean | null;
    isSpecialty: boolean;
    homepagePath?: string;
    code?: string;
};

function HeaderBreadcrumbProfiles({
    dataId,
    dataIcon,
    title,
    dataTitle,
    route,
    dataName,
    isForInvitation = null,
    isSpecialty = false,
    homepagePath,
    code = null,
}: TProps): JSX.Element {
    const navigate = useNavigate();
    const creds = SettingsManager.getConnectionCredentials();
    const [isModal, setIsModal] = useState(false);

    return (
        <>
            <Row className="breadcrumb-header">
                <Col className="header-location">
                    <span>{isForInvitation ? 'Приглашение пользователя' : title}</span>
                </Col>
                {code && (
                    <Col className="header-search" style={{ marginLeft: 'auto' }}>
                        <QRCode size={50} value={code || ' '} onClick={() => setIsModal(true)} />
                    </Col>
                )}
            </Row>
            {!isForInvitation && (
                <Row className="breadcrumbs-controls">
                    <Col className="breadcrumbs">
                        <Breadcrumb>
                            <Breadcrumb.Item
                                onClick={() =>
                                    navigate(homepagePath ?? `/lk/worker/crm/${creds?.crmID}`)
                                }
                            >
                                <FontAwesomeIcon icon={faHouse} />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item onClick={() => navigate(route)}>
                                <FontAwesomeIcon icon={dataIcon} />
                                <span className="crumb-name">{dataTitle}</span>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                {isSpecialty && <span>{dataId}</span>}
                                {!isSpecialty && (
                                    <span>ID: {dataId == -1 ? dataName : dataId}</span>
                                )}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
            )}
            <Modal
                width={350}
                title={false}
                footer={false}
                open={isModal}
                onCancel={() => setIsModal(false)}
            >
                <QRCode size={300} value={code || ' '} />
            </Modal>
        </>
    );
}

export { HeaderBreadcrumbProfiles };
